// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"f5e2fe76","922":"2328e25e"}[chunkId] + ".chunk.js";
};